module.exports = __webpack_public_path__ + "static/media/method-3a.f753e28d.png";